// UK DElivery update 
function updateDeliveryDay() {
  const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  
  function getDeliveryDayText(daysToAdd) {
    const today = new Date();
    today.setDate(today.getDate() + daysToAdd);
    return dayNames[today.getDay()];
  }
  
  const twoDayDeliveryElements = document.querySelectorAll(".delivery-2day");
  const nextDayDeliveryElements = document.querySelectorAll(".delivery-nextday");
  
  twoDayDeliveryElements?.forEach((el) => {
    const dayText = getDeliveryDayText(2);
    el.textContent = `Delivered by ${dayText}`;
  });
  
  nextDayDeliveryElements?.forEach((el) => {
    const dayText = getDeliveryDayText(1);
    el.textContent = `Delivered by ${dayText}`;
  });

}
updateDeliveryDay();